import { getCanonicalCitySlug } from "../config/cityData";

let isLocationRequestInFlight = false;

const getUserLocation = async (
  setUserLocation: Function,
  alertModal?: Function
) => {
  if (isLocationRequestInFlight) return;

  if (typeof window !== "undefined" && navigator.geolocation) {
    isLocationRequestInFlight = true;
    try {
      const position = await new Promise<GeolocationPosition>(
        (resolve, reject) => {
          navigator.geolocation.getCurrentPosition(resolve, reject, {
            enableHighAccuracy: true,
            timeout: 10000, // 10 second timeout
            maximumAge: 60000 // 1 minute cache
          });
        }
      );

      const { latitude, longitude } = position.coords;
      const apiKey = process.env.NEXT_PUBLIC_GOOGLE_MAP_API_KEY;
      // Add language=en parameter to get results in English
      const apiUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${apiKey}&language=en`;

      const response = await fetch(apiUrl);
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      if (data.status === "OK" && data.results.length > 0) {
        const locationName = data.results[0].formatted_address;

        const cityComponent = data.results[0].address_components.find((data: any) =>
          data.types.includes("locality")
        );
        
        if (cityComponent) {
          // Use long_name which should now be in English due to language=en parameter
          let city = cityComponent.long_name;
          
          // Fallback: If city is still not in English, try to find English equivalent
          // This handles cases where Google might still return local language
          if (city && /[\u0900-\u097F]/.test(city)) { // Check if contains Devanagari script
            // Try to find English name in other address components
            const englishCityComponent = data.results[0].address_components.find((comp: any) =>
              comp.types.includes("locality") && comp.long_name && !/[\u0900-\u097F]/.test(comp.long_name)
            );
            
            if (englishCityComponent) {
              city = englishCityComponent.long_name;
            } else {
              // If no English name found, try to map common Hindi city names to English
              const cityMapping: { [key: string]: string } = {
                'दिल्ली': 'Delhi',
                'मुंबई': 'Mumbai',
                'बैंगलोर': 'Bangalore',
                'हैदराबाद': 'Hyderabad',
                'चेन्नई': 'Chennai',
                'कोलकाता': 'Kolkata',
                'पुणे': 'Pune',
                'अहमदाबाद': 'Ahmedabad',
                'जयपुर': 'Jaipur',
                'सूरत': 'Surat',
                'कानपुर': 'Kanpur',
                'नागपुर': 'Nagpur',
                'इंदौर': 'Indore',
                'भोपाल': 'Bhopal',
                'लखनऊ': 'Lucknow',
                'पटना': 'Patna',
                'रांची': 'Ranchi',
                'रायपुर': 'Raipur',
                'श्रीनगर': 'Srinagar',
                'अमृतसर': 'Amritsar'
              };
              
              city = cityMapping[city] || city;
            }
          }
          
          // Only set localStorage if no city is already saved
          const localStorageCity = localStorage.getItem("selectedCity");
          if (!localStorageCity) {
            localStorage.setItem("selectedCity", getCanonicalCitySlug(city));
          }
         
          setUserLocation({
            latitude,
            longitude,
            name: locationName,
            city: getCanonicalCitySlug(city),
          });
        } else {
          console.error("City not found in address components");
          if (alertModal) alertModal();
        }
      } else {
        console.error("Reverse geocoding failed:", data.status);
        if (alertModal) alertModal();
      }
    } catch (error) {
      console.error("Error getting user location:", error);
      if (alertModal) alertModal();
    } finally {
      isLocationRequestInFlight = false;
    }
  } else {
    console.error("Geolocation is not supported by this browser.");
    if (alertModal) alertModal();
  }
};

export default getUserLocation;
